import { Customer } from "msd-capacity-planning-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";

export interface CustomerService {
  fetch(dateFilter?: string): Promise<Customer[]>;
  delete(id: string, dateFilter?: string): Promise<Customer[]>;
  persist(item: Customer, dateFilter?: string): Promise<Customer[]>;
}

class HTTPCustomerService implements CustomerService {
  constructor(private endpoint: string) {}

  async fetch(dateFilter?: string): Promise<Customer[]> {
    const query = dateFilter
      ? `?dateFilter=${encodeURIComponent(dateFilter)}`
      : "";
    return fetchService
      .fetch(`${this.endpoint}/customers${query}`, {})
      .then((r) => r.json())
      .catch((): any[] => []);
  }

  async delete(id: string, dateFilter?: string): Promise<Customer[]> {
    return fetchService
      .fetch(`${this.endpoint}/customers/${id}`, {
        method: "DELETE",
      })
      .then(() => this.fetch(dateFilter));
  }

  async persist(item: Customer, dateFilter?: string): Promise<Customer[]> {
    return fetchService
      .fetch(`${this.endpoint}/customers`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then(() => this.fetch(dateFilter));
  }
}

const service: CustomerService = new HTTPCustomerService(env.endpoint);

export default service;
